const extractVat = (amount, vat = 24) => {
  const vatMultiplier = 1 + vat / 100;

  return Number((amount / vatMultiplier).toFixed(2));
};

export default extractVat;
